import logger from "./logger"


// Resolution array
let resolutionArray = [328*240, 480*360, 640*480, 800*600, 1280*720, 1440*900, 1920*1080];

// Frame rate array
let frameRateArray = [5, 10, 15, 18, 20, 25, 30];

// BitRate control table for h265/vp9
let lowBitRateTable = [
// 5     10   15   18   20   25   30  (fps)
  [130, 180, 220, 230, 240, 260, 290],    // 320*240
  [157, 233, 277, 304, 336, 366, 431],    // 480*360
  [220, 270, 330, 372, 392, 450, 520],    // 640*480
  [230, 305, 393, 483, 505, 610, 725],    // 800*600
  [229, 339, 489, 613, 630, 730, 910],    // 1280*720
  [294, 498, 653, 823, 927, 1151, 1355],  // 1440*900
  [370, 670, 870, 1058, 1150, 1410, 1530] // 1920*1080
];

// BitRate control table for h264/vp8
let highBitRateTable = [
// 5     10   15   18   20   25   30  (fps)
  [50, 100, 150, 180, 200, 250, 300],       // 320*240
  [87, 173, 261, 314, 346, 434, 521],       // 480*360
  [120, 240, 360, 432, 460, 600, 720],      // 640*480
  [187, 375, 563, 675, 700, 900, 1125],     // 800*600
  [239, 479, 719, 863, 900, 1100, 1400],    // 1280*720
  [384, 768, 1153, 1383, 1537, 1921, 2305], // 1440*900
  [480, 960, 1440, 1728, 1920, 2400, 3000]  // 1920*1080
];

/**
 * 获取帧率在帧率表的索引
 * @param {*} frameRate 
 */
function _getFrameRateIndex(frameRate) {
  let index = 0;
  for ( ; index < frameRateArray.length; index++) {
    if (frameRate <= frameRateArray[index]) {
      break;
    }
  }

  // 比最大的帧率还大
  if (index === frameRateArray.length) {
    logger.warn("Frame rate is too big, ", frameRate);
    index--;
  }

  return index;
}

/**
 * 获取分辨率在分辨率表的索引
 * @param {*} width 
 * @param {*} height 
 */
function _getResolutionIndex(width, height) {
  let resolution = width * height;

  let index = 0;
  for ( ; index < resolutionArray.length; index++) {
    if (resolution <= resolutionArray[index]) {
      break;
    }
  }

  // 比最大的分辨率还大
  if (index === resolutionArray.length) {
    logger.warn("Resolution is too big, ", width + "*" + height);
    index--;
  }

  return index;
}

/**
 * 根据视频的宽、高、帧率计算码率
 * @param {*} width 
 * @param {*} height 
 * @param {*} frameRate 
 */
export function getBitRate(width, height, frameRate) {
  let frameIndex = _getFrameRateIndex(frameRate);
  let resolutionIndex = _getResolutionIndex(width, height);
  
  return highBitRateTable[resolutionIndex][frameIndex];
}

/**
 * 生成GUID
 */
export function generateGUID() {
  function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

export function generateId () {
  return parseInt(Math.random() * Math.pow(2, 32))
}
/**
 *  获取websocket地址等字符串
 */
export function getAddrs (str, urlStrs) {
  
  let urlAddrs = urlStrs.split(';')
  let addr = urlAddrs.filter( item =>{
    if(item.indexOf(str) > -1) return item
  })
  return addr.join(';');
}

/**
 * 检测操作系统类型
 */
export function detectOS() { 
  if ((navigator.platform == "Win32") || (navigator.platform == "Windows")) {
    return "windows";
  } else if ((navigator.platform == "Mac68K") 
    || (navigator.platform == "MacPPC") 
    || (navigator.platform == "Macintosh") 
    || (navigator.platform == "MacIntel")) {
    return "mac";
  } else if (String(navigator.platform).indexOf("Linux") > -1) {
    return "linux";
  } else if (navigator.userAgent.indexOf('Android') > -1 
    || navigator.userAgent.indexOf('Linux') > -1) {
    return "android";
  } else if (navigator.userAgent.indexOf('iPhone') > -1) {
    return "ios";
  } else {
    return "unknown";
  }
}

/**
 * 函数同步转异步包装器
 * @param {*} excutor 待执行函数
 */
export function asyncWrapper(excutor) {
  let promise = new Promise(function(resolve) {
    resolve();
  });
  promise.then(()=>{excutor()});
}

/**
 * 打印函数跟踪日志的装饰器
 * @param {*} target 
 * @param {*} name 
 * @param {*} descriptor 
 */
export function tracelog(target, name, descriptor) {
  var oldValue = descriptor.value;

  descriptor.value = function() {
    let argString = "";
    for (let i = 0; i < arguments.length; i++) {
      if (argString) {
        argString += ", " + JSON.stringify(arguments[i])
      } else {
        argString += JSON.stringify(arguments[i])
      }
    }

    if (argString) {
      logger.trace(`${name}: ` + argString);
    } else {
      logger.trace(`"${name}"`);
    }
    
    return oldValue.apply(this, arguments);
  };

  return descriptor;
}

// 两点确定三次贝塞尔曲线函数的两个控制点
export const getCtrlPoint = (ps, i, a, b) => {
  if (!a || !b) {
    a = 0.25;
    b = 0.25;
  }
  // 处理两种极端情形
  if (i < 1) {
    var pAx = parseInt(ps[0].X) + (ps[1].X - ps[0].X) * a;
    var pAy = parseInt(ps[0].Y) + (ps[1].Y - ps[0].Y) * a;
  } else {
    var pAx = parseInt(ps[i].X) + (ps[i + 1].X - ps[i - 1].X) * a;
    var pAy = parseInt(ps[i].Y) + (ps[i + 1].Y - ps[i - 1].Y) * a;
  }
  if (i > ps.length - 3) {
    var last = ps.length - 1
    var pBx = parseInt(ps[last].X) - (ps[last].X - ps[last - 1].X) * b;
    var pBy = parseInt(ps[last].Y) - (ps[last].Y - ps[last - 1].Y) * b;
  } else {
    var pBx = parseInt(ps[i + 1].X) - (ps[i + 2].X - ps[i].X) * b;
    var pBy = parseInt(ps[i + 1].Y) - (ps[i + 2].Y - ps[i].Y) * b;
  }
  return {
    pA: {
      x: pAx,
      y: pAy
    },
    pB: {
      x: pBx,
      y: pBy
    }
  }
}

// 获取字符串的真实长度（字节长度） 
const getTrueLength = (str) => {
  var len = str.length,
    truelen = 0;
  for (var x = 0; x < len; x++) {
    if (str.charCodeAt(x) > 128) {
      truelen += 2;
    } else {
      truelen += 1;
    }
  }
  return truelen;
}

// 按字节长度截取字符串，返回substr截取位置  
const cutString = (str, leng) => {
  var len = str.length,
    tlen = len,
    nlen = 0;
  for (var x = 0; x < len; x++) {
    if (str.charCodeAt(x) > 128) {
      if (nlen + 2 < leng) {
        nlen += 2;
      } else {
        tlen = x;
        break;
      }
    } else {
      if (nlen + 1 < leng) {
        nlen += 1;
      } else {
        tlen = x;
        break;
      }
    }
  }
  return tlen;
}
//ctx_2d        getContext("2d") 对象  
//lineheight    段落文本行高  
//bytelength    设置单字节文字一行内的数量  
//text          写入画面的段落文本  
//startleft     开始绘制文本的 x 坐标位置（相对于画布）  
//starttop      开始绘制文本的 y 坐标位置（相对于画布）  
export const writeTextOnCanvas = (ctx_2d, lineheight, bytelength, text, startleft, starttop) => {
  for (var i = 1; getTrueLength(text) > 0; i++) {
    var tl = cutString(text, bytelength);
    ctx_2d.fillText(text.substr(0, tl).replace(/^\s+|\s+$/, ""), startleft, (i - 1) * lineheight + starttop);
    text = text.substr(tl);
  }
}

/**
 * 预加载白板图片
 * @param {*} url 
 * @param {*} callback 
 * @param {*} n 
 */
export const preloadImage = (url, callback, fail) => {
  let img = new Image()
  img.src = url

  if (img.complete) { // 如果图片已经存在于浏览器缓存，直接调用回调函数     
    callback(img);     
    return; // 直接返回，不用再处理onload事件     
  }
  img.onload = () => {
    callback && callback(img)
  }
  img.onerror = () => {
    fail && fail()
  }
  
}

export const preloadImage1 = (url, complete, success, fail) => {
  let img = new Image()
  img.src = url

  if (img.complete) { // 如果图片已经存在于浏览器缓存，直接调用回调函数     
    complete && complete(img);     
    return; // 直接返回，不用再处理onload事件     
  }
  img.onload = () => {
    success && success(img)
  }
  img.onerror = () => {
    logger.log('img url is Forbidden')
    fail && fail()
  }
  
}

/**
 * 字符串到颜色的转换
 * @param {*} strCL 
 */
export function stringToColor(strCL) {
	var sexadecimalCL;
	// 判断十进制是整型还是字符串，字符串为负数十进制，整型为正数十进制
	if(typeof(strCL) == "string"){
		sexadecimalCL = (parseInt(strCL) >>> 0).toString(16).toLocaleUpperCase();
	}
	else{
		sexadecimalCL = parseInt(strCL).toString(16);
	}
	while(sexadecimalCL.length < 6) {
		sexadecimalCL = "0" + sexadecimalCL;
	}
	// 前端color#RRGGBB，转换成客户端类型#BBGGRR
	var BB = sexadecimalCL.substring(sexadecimalCL.length - 2);
	var GG = sexadecimalCL.substring(sexadecimalCL.length - 4,sexadecimalCL.length - 2);
	var RR = sexadecimalCL.substring(sexadecimalCL.length - 6, sexadecimalCL.length - 4);
	return "#" + RR + GG + BB;
}

export function stringToRGBA(strCL, opacity='1') {
  var R = parseInt(strCL.slice(1, 3), 16)
  var G = parseInt(strCL.slice(3, 5), 16)
  var B = parseInt(strCL.slice(5, 7), 16)
  return `rgba(${R}, ${G}, ${B}, ${opacity})`
}
/**
 * #00000 转换为 256x256x256x256的数字
 */
export function colorToNumber (color) {
  color = (color.charAt(0)=="#") ? color.substring(1,7): color
  while (color.length < 8) {
    color = 'f' + color
  }
  return parseInt(color, 16)
}

/**
 * 有些媒体事件，需要使用后缀进行隔离，否则可能会相互影响
 * @param {*} userId 
 * @param {*} mediaType 
 * @param {*} mediaId 
 */
export function getEventPostfix(userId, mediaType, mediaId) {
  if (userId) {
    return "_" + userId + "_" + mediaType + "_" + mediaId;
  } else {
    return "_" + mediaType + "_" + mediaId;
  }
}
export function concatEventName(eventName, config) {
  if (config !== undefined || config !== null) {
    return eventName + '_' + JSON.stringify(config)
  } else {
    return eventName
  }
}

/**
 * 判断参数是否合法
 * @param {} param 
 */
export function checkParam(param) {
  return param !== null && param !== undefined && param !== '';
}

export function setResize (target, name, descriptor) {
  let oldValue = descriptor.value
  descriptor.value = function (parent, callback, adapterFn) {
    adapterFn = adapterFn || function (resizeHandler) {
      resizeHandler()
    }
    let iframe = this.iframeEl = document.createElement('iframe');
    // 改变样式
    iframe.style.cssText = `
      position: absolute; left: 0; top: 0; width: 100%; height: 100%;
          border: 0; margin: 0; display: block; z-index: -999;
    `;
    // 将其设置为传入对象的孩子元素
    parent.appendChild(iframe);
  
    let oldWidth = parent.offsetWidth;
    let oldHeight = parent.offsetHeight;
  
    // onresize 回调
    function resizeHandler() {
      var newWidth = parent.offsetWidth;
      var newHeight = parent.offsetHeight;
      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        callback && callback({ width: newWidth, height: newHeight }, { width: oldWidth, height: oldHeight });
        oldWidth = newWidth;
        oldHeight = newHeight;
      }
    }
    (iframe.contentWindow || iframe).onresize = function() {
      adapterFn && adapterFn(resizeHandler)
     
    };
    callback({ width: oldWidth, height: oldHeight }, {})
  }
 
}